// src/config/services.js
const services = [
  "AI & Machine Learning",
  "Cybersecurity",
  "Software & Web Development",
  "Cloud & DevOps",
  "Data & Analytics",
  "Compliance & Risk Consulting",
];

export default services;
